import React, { useEffect } from 'react'
import Router from 'router'
import { updateMetaConfig } from 'hooks/useMetaConfig'

function App() {
    useEffect(() => {
        updateMetaConfig()
    }, [])

    return <Router />
}

export default App
